<script>
import Drawer from "@/components/drawer";
import draggable from "vuedraggable";
import Swal from "sweetalert2";

// Custom components
import PageHeader from "@/components/page-header";
import HealthQuestionForm from "@/components/HealthQuestionsForm";
import hkService from "@/helpers/APIService/hk.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Health Questions",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  name: "HealthQuestions",
  components: {
    PageHeader,
    Drawer,
    draggable,
    HealthQuestionForm,
  },
  data() {
    return {
      title: "Health Questions",
      dragging: false,
      isShowHealthQuestion: false,
      healthQuestions: [],
      selectedQuestion: null,
      questionEdit: false,
      questionIndex: null,
    };
  },
  computed: {
    ...authComputed,
    helthQuestionProps() {
      return {
        selectedQuetionId: this.selectedQuetionId,
        questionEdit: this.questionEdit,
        questionIndex: this.questionIndex,
      };
    },
  },
  mounted() {
    this.getHealthQuestions();
  },
  methods: {
    healthQuestionDrawer() {
      if (this.isShowHealthQuestion == true) {
        this.selectedQuetionId = null;
        this.questionEdit = false;
        this.questionIndex = null;
      }
      this.isShowHealthQuestion = !this.isShowHealthQuestion;
    },
    getHealthQuestions() {
      hkService
        .getHealthSheetList()
        .then((healthQuestion) => {
          this.healthQuestions = healthQuestion;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for add new health question
    questionAdded(question, questionEdit, index) {
      if (questionEdit) {
        this.healthQuestions[index] = question;
      } else {
        this.healthQuestions.push(question);
      }
      this.healthQuestionDrawer();
    },
    // Method is use for update health question based on id
    editHealthQuestion(question, index) {
      this.selectedQuetionId = question.id;
      this.questionEdit = true;
      this.questionIndex = index;
      this.healthQuestionDrawer();
    },
    saveAndAddNewHealthQuestion(question) {
      this.healthQuestions.push(question);
    },
    // Method is use for delete a health question based on id
    async deleteHealthQuestion(question_id, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          hkService
            .deleteHealthQuestion(question_id)
            .then(() => {
              Middleware.notification("Successfully deleted !!", "danger");
              this.isLoading = false;
              this.healthQuestions.splice(index, 1);
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    // Method is use change health question order
    onChoose: function (evt) {
      const questionData = new FormData();
      questionData.append("priority_order", evt.moved.newIndex + 1);
      hkService
        .updateHealthQuestion(evt.moved.element.id, questionData)
        .then(() => {
          Middleware.notification("Question positions changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" />
    <template>
      <draggable
        v-model="healthQuestions"
        @change="
          (e) => {
            onChoose(e);
          }
        "
      >
        <div
          class="row"
          v-for="(helthQuestion, index) in healthQuestions"
          :key="index"
        >
          <div class="col-6">
            <b-card header-class="bg-transparent">
              <h5 class="card-title mt-0">
                {{ index + 1 }}.
                {{ helthQuestion.question_text }}
                <span class="text-danger" v-if="helthQuestion.is_required"
                  >*</span
                >
                <span class="text-end float-end">
                  <a
                    :id="String(index)"
                    href="javascript:void(0)"
                    v-b-popover.hover.top="'Edit custom question.'"
                    @click="editHealthQuestion(helthQuestion, index)"
                    ><i class="fas fa-pencil-alt"></i
                  ></a>
                  <a
                    :id="String(index)"
                    href="javascript:void(0)"
                    v-b-popover.hover.top="'Delete custom question.'"
                    @click="deleteHealthQuestion(helthQuestion.id, index)"
                    class="ms-2"
                    ><i class="mdi mdi-trash-can ms-2 fs-5 text-danger"></i
                  ></a>
                </span>
              </h5>
              <div
                class="row card-text"
                v-if="
                  helthQuestion.answer_type == 'date' ||
                  helthQuestion.answer_type == 'time' ||
                  helthQuestion.answer_type == 'number' ||
                  helthQuestion.answer_type == 'time' ||
                  helthQuestion.answer_type == 'phone' ||
                  helthQuestion.answer_type == 'email' ||
                  helthQuestion.answer_type == 'text' ||
                  helthQuestion.answer_type == 'file'
                "
              >
                <div class="col-md-12">
                  <input
                    :type="helthQuestion.answer_type"
                    class="form-control form-control-sm"
                    readonly
                    :required="helthQuestion.is_required"
                  />
                </div>
              </div>
              <div
                class="row card-text"
                v-if="helthQuestion.answer_type == 'textarea'"
              >
                <div class="col-md-12">
                  <textarea
                    class="form-control form-control-sm"
                    cols="5"
                    :required="helthQuestion.is_required"
                    rows="5"
                  ></textarea>
                </div>
              </div>
              <div
                class="row card-text"
                v-if="helthQuestion.answer_type == 'radio'"
              >
                <div class="col-md-12">
                  <b-form-group>
                    <b-form-radio
                      :id="String(index)"
                      class="mb-2"
                      value="a"
                      name="selectOption"
                      plain
                      >Yes
                    </b-form-radio>
                    <b-form-radio
                      :id="String(index)"
                      name="selectOption"
                      value="b"
                      plain
                      >No</b-form-radio
                    >
                  </b-form-group>
                </div>
              </div>
              <div
                class="row card-text"
                v-if="
                  helthQuestion.answer_type == 'multi_select' ||
                  helthQuestion.answer_type == 'choice'
                "
              >
                <div
                  class="col-md-12"
                  v-for="(customeCheckbox, index) in helthQuestion.form_data"
                  :key="index"
                >
                  <b-form-checkbox
                    value="accepted"
                    unchecked-value="not_accepted"
                    class="mb-2"
                    checked
                    plain
                    >{{ customeCheckbox.option }}</b-form-checkbox
                  >
                </div>
              </div>
            </b-card>
          </div>
        </div>
      </draggable>
      <button
        type="button"
        class="btn btn-primary"
        @click="healthQuestionDrawer"
      >
        + Add Another
      </button>
    </template>
    <!-- Health Question drawer -->
    <Drawer
      @close="healthQuestionDrawer"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="isShowHealthQuestion">
        <div class="text-black">
          <HealthQuestionForm
            :currentProps="helthQuestionProps"
            @submitted="questionAdded"
            @cancelSubmit="healthQuestionDrawer"
            @saveAndAddNew="saveAndAddNewHealthQuestion"
          />
        </div>
      </div>
    </Drawer>
  </div>
</template>
